import { render, staticRenderFns } from "./nav1.vue?vue&type=template&id=65fedef2&scoped=true&"
import script from "./nav1.vue?vue&type=script&lang=js&"
export * from "./nav1.vue?vue&type=script&lang=js&"
import style0 from "./nav1.vue?vue&type=style&index=0&id=65fedef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fedef2",
  null
  
)

export default component.exports